import { render, staticRenderFns } from "./page-confirmation.vue?vue&type=template&id=2f817c7d"
import script from "./page-confirmation.js?vue&type=script&lang=js&external"
export * from "./page-confirmation.js?vue&type=script&lang=js&external"
import style0 from "./page-confirmation.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports